import { gql } from '../../../apollo/__generated__';

export const LEAVE_EVENT = gql(`
  mutation LeaveEvent($leaveEventInput: LeaveEventInput!) {
    leaveEvent(leaveEventInput: $leaveEventInput) {
      id
      hasJoined
      waitingListPosition
    }
  }
`);
